import React from 'react'
import AboutMe from '../../components/AboutMe'
import './about.css'

const About = () => {
    return (
        <div className="container">
                
                <AboutMe />
                
                
            </div>
    )
}

export default About
